// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"5314770d67f4a69d","4471":"a16a632bf0e30cd9","7767":"fe65eed7185aa266"}[chunkId] + ".js";
};